import { createGlobalStyle, ThemeProps } from "styled-components";

import { Theme } from "./theme";
import { EThemeType } from "redux/reducers";

interface IProp {
  currenttheme?: EThemeType;
  sidebarWidth?: number;
}

const GlobalStyle = createGlobalStyle<ThemeProps<Theme> & IProp>`
  #__next,
  html,
  body,
  #root {
    height: 100vh;
    width: 100%;
    padding: 0;
    margin: 0;
    font-weight: normal;
    -webkit-font-smoothing: antialiased;
    color: ${({ theme }) => theme.textColor};
    font-family: ${({ theme }) => theme.ralewayFont};
    background-color: ${({ currenttheme }) =>
    currenttheme === 'dark' ? '#171718' : 'rgb(255, 255, 255)'};
    font-size: 14px;
    min-height: 100vh;
  }
  
  button, input, textarea {
    font-family: ${({ theme }) => theme.ralewayFont};
  }
  
  * {
    box-sizing: border-box;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  
  li {
    margin: 0;
    padding: 0;
  }

  ::-webkit-scrollbar{
      width: 4px;
      height: 4px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${({ currenttheme }) =>
    currenttheme === 'dark' ? 'rgba(255,255,255,.7)' : '#848485'};
  }

  .ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: rippleAnimation 0.6s linear;
    pointer-events: none;
    background-color: rgba(67, 56, 202, 0.3);
}

@keyframes rippleAnimation {
    0% {
        transform: scale(0);
        opacity: 1;
    }
    100% {
        transform: scale(2.5);
        opacity: 0;
    }
}

`;

export default GlobalStyle;
